// Author Lin
// Date 2021-11-20 11:27:17

class MintalMesPrdSmeltingMaterialBatching {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                productionTime = '',
                furnaceId = '',
                furnaceName = '',
                furnaceBatch = '',
                cokeQuantity = '',
                silicaQuantity = '',
                ballQuantity = '',
                heavyDregsQuantity = '',
                serpentineQuantity = '',
                dolomiteQuantity = '',
                reason = '',
                operatorId = '',
                operator = '',
                principalId = '',
                principal = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.productionTime = productionTime;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.furnaceBatch = furnaceBatch;
            this.cokeQuantity = cokeQuantity;
            this.silicaQuantity = silicaQuantity;
            this.ballQuantity = ballQuantity;
            this.heavyDregsQuantity = heavyDregsQuantity;
            this.serpentineQuantity = serpentineQuantity;
            this.dolomiteQuantity = dolomiteQuantity;
            this.reason = reason;
            this.operatorId = operatorId;
            this.operator = operator;
            this.principalId = principalId;
            this.principal = principal;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingMaterialBatching();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'productionTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.productionTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceBatch',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.furnaceBatch',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cokeQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.cokeQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'silicaQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.silicaQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'ballQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.ballQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heavyDregsQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.heavyDregsQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'serpentineQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.serpentineQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dolomiteQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.dolomiteQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reason',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.reason',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'operatorId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.operatorId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'operator',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.operator',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'principalId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.principalId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'principal',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.principal',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            productionTimeRteFilter : '',
            productionTimeLteFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            furnaceBatchFilter : '',
            cokeQuantityFilter : '',
            silicaQuantityFilter : '',
            ballQuantityFilter : '',
            heavyDregsQuantityFilter : '',
            serpentineQuantityFilter : '',
            dolomiteQuantityFilter : '',
            reasonFilter : '',
            operatorIdFilter : '',
            operatorFilter : '',
            principalIdFilter : '',
            principalFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'productionTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.productionTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'productionTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.productionTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'furnaceBatchFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.furnaceBatch',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cokeQuantityFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.cokeQuantity',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'silicaQuantityFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.silicaQuantity',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'ballQuantityFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.ballQuantity',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heavyDregsQuantityFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.heavyDregsQuantity',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'serpentineQuantityFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.serpentineQuantity',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dolomiteQuantityFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.dolomiteQuantity',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'reasonFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.reason',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'operatorFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.operator',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"operatorId":"id"}'
                        }
                },
                {
                key: 'principalFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.filter.principal',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"principalId":"id"}'
                        }
                }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'productionTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.productionTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'furnaceBatch',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.furnaceBatch',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cokeQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.cokeQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'silicaQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.silicaQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'ballQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.ballQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heavyDregsQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.heavyDregsQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'serpentineQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.serpentineQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dolomiteQuantity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.dolomiteQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'reason',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.reason',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'operator',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.operator',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"operatorId":"id"}'
                        }
                },
                {
                key: 'principal',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.principal',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"principalId":"id"}'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingMaterialBatching.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingMaterialBatching, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        